import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, ArrowRightIcon } from 'lucide-react';
export function BeforeAfter() {
  return <section className="py-24 bg-forest-dark relative overflow-hidden" data-id="element-13">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#C2A55E_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-14"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-16">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative group" data-id="element-17">
            <div className="rounded-3xl overflow-hidden shadow-2xl border-2 border-gold/20" data-id="element-18">
              <img src="https://cdn.magicpatterns.com/uploads/ezyWKGHb2P1QE9ryNCQdMV/MJ6.png" alt="Before and After Landscaping Transformation by Manny's The Green Mountain Landscaping" className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-19" />
            </div>
            {/* Decorative corner accent */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-gold/30 rounded-2xl -z-10" data-id="element-20"></div>
            <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-gold/30 rounded-2xl -z-10" data-id="element-21"></div>
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-22">
            <span className="text-gold font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-23">
              The Manny's Difference
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif leading-tight" data-id="element-24">
              See the <span className="text-gold italic" data-id="element-25">Transformation</span>
            </h2>
            <div className="w-16 h-1.5 bg-gold rounded-full mb-8" data-id="element-26"></div>
            <p className="text-gray-300 text-lg md:text-xl font-light leading-relaxed mb-8" data-id="element-27">
              From overgrown and neglected to pristine and professional — our
              team delivers dramatic results that completely transform your
              property's curb appeal and value.
            </p>
            <p className="text-gray-400 text-base font-light leading-relaxed mb-10" data-id="element-28">
              Every project starts with a free estimate and a clear plan. We
              handle everything from cleanup to full landscape design, so you
              can sit back and watch the transformation happen.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-29">
              <a href="#contact" className="group/btn flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-forest-dark px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-[0_0_30px_rgba(194,165,94,0.4)]" data-id="element-30">
                Get Your Free Estimate
                <ArrowRightIcon className="w-5 h-5 group-hover/btn:translate-x-1 transition-transform" data-id="element-31" />
              </a>
              <a href="tel:360-623-4531" className="flex items-center justify-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/20 px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300" data-id="element-32">
                <PhoneIcon className="w-5 h-5 text-gold" data-id="element-33" />
                360-623-4531
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}